/**
 * DS Shipping Bar – Icon + Text + Fortschrittsbalken (geo-aware v2, 2026-06-12)
 *
 * v2: Landesbewusst. Der Banner versprach AT/CH-Kunden den DE-Gratis-Versand,
 * den es fuer sie nicht gibt (Conversion-Killer + UWG-Risiko).
 *
 * Modi:
 *   DE (Default + Fallback): unveraendertes Verhalten, Gratis ab 79,99 EUR
 *   AT: ehrliche Versandinfo (ab 14,99 EUR) – KEIN Gratis-Versprechen,
 *       solange AT_FREE_THRESHOLD null ist. Wird die AT-Gratis-Regel im
 *       Checkout aktiviert, hier Schwelle in Cents eintragen (z.B. 14900):
 *       dann zeigt AT eine eigene Progression. Schwere Artikel (>= 3 kg,
 *       eigenes Versandprofil) sind vom Versprechen ausgenommen (Guard).
 *   CH: ehrliche Versandinfo (ab 19,99 EUR), kein Versprechen.
 *
 * Geo-Quelle: https://sitemap.dogssupreme.de/geo (Cloudflare Edge-Land,
 * keine IP-Speicherung). Cache: sessionStorage. Test: ?ds_geo=AT
 * Fallback bei Fetch-Fehler/Timeout: DE-Modus (87,6% der Kunden).
 *
 * Abhaengigkeiten: Keine (standalone)
 * Events empfaengt: cart:updated, ajaxProduct:added, drawerOpen.CartDrawer
 * Events sendet: ds_shipping_bar_view, ds_shipping_bar_reached,
 *                ds_shipping_bar_geo (dataLayer)
 *
 * SICHERHEIT:
 * - Message-Templates sind hardcodierte Konstanten (keine User-Eingabe)
 * - Geo-Antwort wird auf [A-Z]{2} validiert, alles andere -> DE
 * - innerHTML wird ausschliesslich mit vordefinierten, sicheren Strings befuellt
 */
(function() {
  'use strict';

  // ── Konstanten ──────────────────────────────────────────────────────
  var THRESHOLD = 7999;             // DE: Gratis ab 79,99 EUR
  // Beutezeit-Frischfutter: Mindestbestellwert 15,00 EUR (Manufaktur Schurig, eigenes Lager/2. Versand).
  // Blockt Checkout NUR wenn 0 < Beutezeit-Anteil < 15 EUR. Dieselbe Bar zeigt die MOV-Botschaft.
  var MOV_THRESHOLD = 1500;
  var MOV_VENDOR = 'Beutezeit';
  // Kuratierte Auffuell-Vorschlaege im Hinweis-Modal (verifizierte Beutezeit-Handles).
  var MOV_SUGGEST = [
    { h: 'hundesnack-rinderlunge-500g', n: 'Rinderlunge 500g' },
    { h: 'barf-mix-rind-tiefgekuehlt', n: 'BARF-Mix Rind 1kg' },
    { h: 'nassfutter-rind-gereift-400g', n: 'Nassfutter Rind im Glas' }
  ];
  var AT_FREE_THRESHOLD = 14900;    // AT: Gratis ab 149,00 EUR (Checkout-Regel live seit 13.06.2026,
                                    // draftOrder-verifiziert). Schwere Artikel (>=3kg, eigenes
                                    // Versandprofil) sind per hasHeavyItem-Guard ausgenommen.
  var HEAVY_ITEM_GRAMS = 3000;      // Artikel ab 3 kg = eigenes Versandprofil, kein Gratis
  var GEO_ENDPOINT = 'https://sitemap.dogssupreme.de/geo';
  var GEO_TIMEOUT_MS = 1500;

  // Sperrgut-Artikel (eigenes Versandprofil, Aufschlag IMMER faellig, nie gratis).
  // FlexBox Pro Hunde-Transportbox. Versand pro Land in SPERRGUT_FEE.
  var SPERRGUT_PRODUCT_IDS = [10696890843403, 10987820384523];  // FlexBox Pro + SafeRide Pro Auto-Hundebox
  var FROZEN_SNACK_HANDLES = ['leckerli-teig-rind-1kg','hundesnack-rindernase-250g','hundesnack-rinderknochen-250g','hundesnack-rinderkehlkopf-250g','hundesnack-huehnerfuesse-250g']; // tiefgekuehlte Snacks -> TK-Versand
  var FROZEN_INCLUDED_HANDLES = ['barf-kennenlern-box']; // frozen, aber Kuehlversand im Preis -> kein 14,50-Hinweis
  var SPERRGUT_FEE = { DE: '28,99 €', AT: '29,75 €', CH: '30,00 €' };

  var MESSAGES = {
    mov: 'Beutezeit: noch <strong>{amount}</strong> bis 15 € Mindestbestellwert',
    far: 'Noch <strong>{amount}</strong> bis gratis Versand – spare 6,99 €',
    almost: 'Nur noch <strong>{amount}</strong> – dann sparst du 6,99 € Versand!',
    reached: '<strong>Gratis-Versand!</strong> – 6,99 € gespart',
    atInfo: 'Versand nach Österreich: ab <strong>14,99 €</strong> · DHL GoGreen',
    atFar: 'Noch <strong>{amount}</strong> bis gratis Versand nach Österreich',
    atAlmost: 'Nur noch <strong>{amount}</strong> – dann ist dein Versand nach Österreich gratis!',
    atReached: '<strong>Gratis-Versand nach Österreich!</strong>',
    chInfo: 'Versand in die Schweiz: ab <strong>19,99 €</strong> · DHL GoGreen',
    sperrgut: 'Transportbox (Sperrgut): <strong>{fee}</strong> Speditionsversand',
    frozen: 'Tiefkühlartikel: <strong>14,50 €</strong> Kühlversand (DPD Food Express)'
  };

  var ICONS = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke="currentColor">'
      + '<rect x="1" y="3" width="15" height="13"></rect>'
      + '<polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>'
      + '<circle cx="5.5" cy="18.5" r="2.5"></circle>'
      + '<circle cx="18.5" cy="18.5" r="2.5"></circle></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke="currentColor"'
      + ' stroke-linecap="round" stroke-linejoin="round">'
      + '<circle cx="12" cy="12" r="10"></circle>'
      + '<path d="m9 12 2 2 4-4"></path></svg>'
  };

  // ── Mutable State (ueberlebt DOM-Replacement) ─────────────────────
  var state = {
    total: 0,
    reachedBefore: false,
    viewFired: false,
    country: 'DE',          // Default + Fallback
    geoResolved: false,
    hasHeavyItem: false,
    hasSperrgut: false,
    hasFrozen: false,
    beutezeitSum: 0          // Cent-Summe der Beutezeit-Artikel (vendor-basiert), fuer MOV-Gate
  };

  // Initialen Cart-Wert aus JSON-Config lesen (falls vorhanden)
  (function initState() {
    var cfgEl = document.querySelector('[data-ds-shipping-config]');
    if (!cfgEl) return;
    try {
      var cfg = JSON.parse(cfgEl.textContent);
      state.total = cfg.cartTotal || 0;
      state.reachedBefore = state.total >= THRESHOLD;
    } catch (e) { /* ignore parse errors */ }
  })();

  // ── Geo-Erkennung ──────────────────────────────────────────────────
  function applyCountry(cc) {
    if (!/^[A-Z]{2}$/.test(cc)) cc = 'DE';
    var changed = state.country !== cc;
    state.country = cc;
    state.geoResolved = true;
    if (changed) {
      pushEvent('ds_shipping_bar_geo', { ds_geo_country: cc });
      update(state.total);
    }
  }

  (function initGeo() {
    // Test-Override: ?ds_geo=AT
    var m = window.location.search.match(/[?&]ds_geo=([A-Za-z]{2})/);
    if (m) {
      try { sessionStorage.setItem('ds_geo', m[1].toUpperCase()); } catch (e) {}
      applyCountry(m[1].toUpperCase());
      return;
    }
    try {
      var cached = sessionStorage.getItem('ds_geo');
      if (cached) { applyCountry(cached); return; }
    } catch (e) { /* sessionStorage gesperrt -> einfach fetchen */ }

    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function() { ctrl.abort(); }, GEO_TIMEOUT_MS) : null;
    fetch(GEO_ENDPOINT, { signal: ctrl ? ctrl.signal : undefined })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (timer) clearTimeout(timer);
        var cc = String(d.country || 'DE').toUpperCase();
        try { sessionStorage.setItem('ds_geo', cc); } catch (e) {}
        applyCountry(cc);
      })
      .catch(function() {
        if (timer) clearTimeout(timer);
        // Endpoint nicht erreichbar -> DE-Default bleibt (87,6% der Kunden)
        state.geoResolved = true;
      });
  })();

  // ── Schwere Artikel im Cart? (eigenes Versandprofil, kein AT-Gratis) ─
  function refreshHeavyFlag(cart) {
    if (!cart || !cart.items) return;
    state.hasHeavyItem = cart.items.some(function(it) {
      return (it.grams || 0) >= HEAVY_ITEM_GRAMS;
    });
    state.hasSperrgut = cart.items.some(function(it) {
      return SPERRGUT_PRODUCT_IDS.indexOf(it.product_id) !== -1;
    });
    state.hasFrozen = cart.items.some(function(it) {
      var h = it.handle || '';
      if (FROZEN_INCLUDED_HANDLES.indexOf(h) !== -1) return false;
      return h.indexOf('barf') === 0 || FROZEN_SNACK_HANDLES.indexOf(h) !== -1;
    });
    // Beutezeit-Anteil summieren (vendor-basiert). Nur ueberschreiben, wenn das Cart-Objekt
    // vendor-Felder mitbringt (cart.js tut das immer) -> verhindert versehentliches Entsperren
    // bei einem vendor-losen cart:updated-Payload.
    var sawVendor = false, bz = 0;
    cart.items.forEach(function(it) {
      if (typeof it.vendor !== 'undefined') sawVendor = true;
      if ((it.vendor || '') === MOV_VENDOR) {
        bz += (it.final_line_price != null ? it.final_line_price : it.line_price);
      }
    });
    if (sawVendor) state.beutezeitSum = bz;
  }

  // ── Beutezeit-Mindestbestellwert: Checkout-Sperre + Bar-Botschaft ───
  function ensureBlockCss() {
    if (document.getElementById('ds-bz-block-css')) return;
    var s = document.createElement('style');
    s.id = 'ds-bz-block-css';
    s.textContent =
      // gesperrtes Element bleibt KLICKBAR (oeffnet Modal), nur visuell gedimmt. Fail-safe via type/href-Entzug im JS.
        '.ds-bz-blocked{opacity:.45!important;filter:grayscale(.3);cursor:pointer!important}'
      + '.ds-bz-hide{display:none!important}'
      // ── Hinweis-Modal (Apple 2026, mobile-first) ──
      + '.ds-bz-modal{position:fixed;inset:0;z-index:2147483000;display:none;font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text","SF Pro Display","Segoe UI",Roboto,sans-serif;-webkit-font-smoothing:antialiased}'
      + '.ds-bz-modal.is-open{display:block}'
      + '.ds-bz-modal__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.5);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);animation:dsBzFade .25s ease}'
      + '@keyframes dsBzFade{from{opacity:0}to{opacity:1}}'
      + '.ds-bz-modal__card{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:calc(100% - 36px);max-width:420px;max-height:calc(100vh - 48px);overflow-y:auto;-webkit-overflow-scrolling:touch;background:#fff;border-radius:26px;padding:30px 26px 20px;box-shadow:0 30px 80px rgba(0,0,0,.32);animation:dsBzPop .3s cubic-bezier(.2,.9,.25,1)}'
      + '@keyframes dsBzPop{from{opacity:0;transform:translate(-50%,-46%) scale(.96)}to{opacity:1;transform:translate(-50%,-50%) scale(1)}}'
      + '.ds-bz-modal__grip{display:none}'
      + '.ds-bz-modal__x{position:absolute;top:14px;right:16px;width:30px;height:30px;border:0;border-radius:50%;background:rgba(0,0,0,.05);color:#6e6e73;font-size:20px;line-height:30px;text-align:center;cursor:pointer;padding:0;transition:background .15s}'
      + '.ds-bz-modal__x:hover{background:rgba(0,0,0,.1)}'
      + '.ds-bz-modal__title{font-size:22px;font-weight:600;letter-spacing:-.022em;line-height:1.2;color:#1d1d1f;margin:0 26px 10px 0}'
      + '.ds-bz-modal__body{font-size:14px;line-height:1.5;color:#6e6e73;margin:0 0 16px}'
      + '.ds-bz-modal__progress{height:6px;border-radius:99px;background:rgba(0,0,0,.07);overflow:hidden;margin:0 0 20px}'
      + '.ds-bz-modal__progress>span{display:block;height:100%;background:#0066cc;border-radius:99px;transition:width .5s cubic-bezier(.3,.9,.3,1)}'
      + '.ds-bz-modal__lead{font-size:11.5px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:#86868b;margin:0 0 10px}'
      + '.ds-bz-modal__suggest{display:flex;flex-direction:column;gap:8px;margin:0 0 8px}'
      + '.ds-bz-modal__add{display:flex;align-items:center;gap:13px;width:100%;text-align:left;border:.5px solid rgba(0,0,0,.1);background:#fff;border-radius:16px;padding:10px 12px;cursor:pointer;transition:background .15s,border-color .15s,box-shadow .15s;-webkit-tap-highlight-color:transparent}'
      + '.ds-bz-modal__add:hover{background:#fafafa;border-color:rgba(0,0,0,.16);box-shadow:0 2px 10px rgba(0,0,0,.05)}'
      + '.ds-bz-modal__add:active{transform:scale(.99)}'
      + '.ds-bz-modal__add:disabled{opacity:.55;cursor:default}'
      + '.ds-bz-modal__add-thumb{width:48px;height:48px;flex-shrink:0;border-radius:11px;object-fit:cover;background:#f5f5f7}'
      + '.ds-bz-modal__add-info{flex:1;min-width:0}'
      + '.ds-bz-modal__add-name{display:block;font-size:14.5px;font-weight:600;letter-spacing:-.01em;color:#1d1d1f;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
      + '.ds-bz-modal__add-sub{display:block;font-size:12px;color:#86868b;margin-top:1px}'
      + '.ds-bz-modal__add-price{font-size:14px;font-weight:600;color:#1d1d1f;white-space:nowrap}'
      + '.ds-bz-modal__add-plus{flex-shrink:0;width:28px;height:28px;border-radius:50%;background:#0066cc;display:flex;align-items:center;justify-content:center}'
      + '.ds-bz-modal__add-plus svg{width:14px;height:14px;display:block}'
      + '.ds-bz-modal__remove{display:block;width:100%;border:0;border-top:.5px solid rgba(0,0,0,.08);background:none;color:#86868b;font:500 14px/1.3 inherit;padding:15px 8px 6px;margin-top:8px;cursor:pointer;transition:color .15s;-webkit-tap-highlight-color:transparent}'
      + '.ds-bz-modal__remove:hover{color:#1d1d1f}'
      + '@media(max-width:540px){'
      +   '.ds-bz-modal__card{left:0;top:auto;bottom:0;transform:none;width:100%;max-width:none;max-height:88vh;border-radius:24px 24px 0 0;padding:12px 20px calc(22px + env(safe-area-inset-bottom));animation:dsBzSheet .34s cubic-bezier(.2,.9,.25,1)}'
      +   '@keyframes dsBzSheet{from{transform:translateY(100%)}to{transform:translateY(0)}}'
      +   '.ds-bz-modal__grip{display:block;width:38px;height:5px;border-radius:99px;background:rgba(0,0,0,.18);margin:0 auto 14px}'
      +   '.ds-bz-modal__title{font-size:21px}'
      + '}'
      + '@media(prefers-reduced-motion:reduce){.ds-bz-modal__backdrop,.ds-bz-modal__card{animation:none}.ds-bz-modal__progress>span{transition:none}}';
    document.head.appendChild(s);
  }

  // Ist der Beutezeit-Gate aktiv? (0 < Beutezeit-Anteil < 15 EUR). Single Source of Truth fuer den funktionalen Gate.
  function movIsActive() {
    return state.beutezeitSum > 0 && state.beutezeitSum < MOV_THRESHOLD;
  }

  // ── Funnel-Tracking (dataLayer/GTM). Alle Events mit Praefix ds_bz_mov_ ──
  // -> in GTM per EINEM Custom-Event-Trigger (Regex ds_bz_mov_.*) + EINEM GA4-Event-Tag erfassbar.
  function movTrack(name, extra) {
    var sum = state.beutezeitSum || 0;
    var p = {
      ds_bz_sum: +(sum / 100).toFixed(2),                               // aktueller Beutezeit-Anteil EUR
      ds_bz_missing: +(Math.max(0, MOV_THRESHOLD - sum) / 100).toFixed(2), // fehlend bis 15 EUR
      ds_bz_context: (window.location.pathname.indexOf('/cart') === 0 ? 'cart_page' : 'drawer')
    };
    if (extra) { for (var k in extra) { if (extra.hasOwnProperty(k)) p[k] = extra[k]; } }
    pushEvent('ds_bz_mov_' + name, p);                                  // dataLayer (GTM-bereit, falls Tags ergaenzt werden)
    try { if (typeof window.gtag === 'function') window.gtag('event', 'ds_bz_mov_' + name, p); } catch (e) {} // direkt an GA4 (G-Q6QSQSL1VM)
  }

  // VISUELL markieren/entmarken (gedimmter Button + Express verstecken). Best-effort.
  // Der FUNKTIONALE Gate ist die zentrale Klick-/Submit-Abfangung per Selektor + Live-State
  // (re-render-fest, haengt NICHT an dieser Markierung -> war die Bypass-Ursache).
  function applyCheckoutBlock(block) {
    ensureBlockCss();
    var i, els = document.querySelectorAll('button[name="checkout"],a[href="/checkout"],a[href^="/checkout?"]');
    for (i = 0; i < els.length; i++) {
      els[i].classList.toggle('ds-bz-blocked', block);
      if (block) els[i].setAttribute('aria-disabled', 'true'); else els[i].removeAttribute('aria-disabled');
    }
    var express = document.querySelectorAll('.additional-checkout-buttons,.dynamic-checkout__content,[data-shopify="dynamic-checkout-cart"]');
    for (i = 0; i < express.length; i++) { express[i].classList.toggle('ds-bz-hide', block); }
  }

  // Setzt die MOV-Botschaft auf ALLE Bars (Cart-Page-Bar + versteckte Drawer-Bar),
  // damit auch der Drawer auf der Cart-Seite konsistent ist. Vor dem ersten Override
  // wird der Originalzustand je Bar gestasht (data-Attribute) -> sauberes Restore.
  function renderMov() {
    var remaining = Math.max(0, MOV_THRESHOLD - state.beutezeitSum);
    var pct = Math.min(100, (state.beutezeitSum / MOV_THRESHOLD) * 100);
    var bars = document.querySelectorAll('.ds-shipping-bar');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var msg = bar.querySelector('.ds-shipping-bar__message');
      var fill = bar.querySelector('.ds-shipping-bar__fill');
      var icon = bar.querySelector('.ds-shipping-bar__icon');
      var track = bar.querySelector('.ds-shipping-bar__track');
      if (!bar.hasAttribute('data-ds-mov-prev')) {
        bar.setAttribute('data-ds-mov-prev', '1');
        if (msg) bar.setAttribute('data-ds-prev-msg', msg.innerHTML);
        if (fill) bar.setAttribute('data-ds-prev-fill', fill.style.width || '');
      }
      if (track) track.style.display = '';
      if (fill) { fill.style.width = pct + '%'; fill.classList.remove('ds-shipping-bar__fill--reached'); }
      if (icon) { icon.innerHTML = ICONS.truck; icon.classList.remove('ds-shipping-bar__icon--reached'); } // safe: hardcoded
      if (msg) setMessageContent(msg, MESSAGES.mov, formatEUR(remaining));
      if (track) track.setAttribute('aria-valuenow', String(Math.round(pct)));
    }
    if (!window.__dsBzBarViewFired) { window.__dsBzBarViewFired = 1; movTrack('bar_view'); } // Impression: Gate sichtbar
  }

  // Stellt nach MOV-Deaktivierung den gestashten Originalzustand je Bar wieder her.
  // Die sichtbare Kontext-Bar wird danach von der normalen Logik (renderProgress) live ueberschrieben.
  function clearMovBars() {
    var bars = document.querySelectorAll('.ds-shipping-bar[data-ds-mov-prev]');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var msg = bar.querySelector('.ds-shipping-bar__message');
      var fill = bar.querySelector('.ds-shipping-bar__fill');
      if (msg && bar.hasAttribute('data-ds-prev-msg')) msg.innerHTML = bar.getAttribute('data-ds-prev-msg'); // safe: eigener, zuvor gestashter Inhalt
      if (fill && bar.hasAttribute('data-ds-prev-fill')) fill.style.width = bar.getAttribute('data-ds-prev-fill');
      bar.removeAttribute('data-ds-mov-prev');
      bar.removeAttribute('data-ds-prev-msg');
      bar.removeAttribute('data-ds-prev-fill');
    }
  }

  // ── Hinweis-Modal (Conversion-Rescue beim Klick auf gesperrten Checkout) ──
  // Transparenter Hinweis + zwei Wege: (1) 1-Klick Frischfutter ergaenzen (AOV, on-strategy),
  // (2) ohne Frischfutter zur Kasse (rettet den Geschirr-Verkauf). Kein Dead-End.
  var movDirty = false; // im Modal wurde der Korb veraendert -> beim Schliessen Seite syncen

  function buildMovModal() {
    if (document.getElementById('ds-bz-modal')) return;
    var w = document.createElement('div');
    w.id = 'ds-bz-modal';
    w.className = 'ds-bz-modal';
    w.setAttribute('role', 'dialog');
    w.setAttribute('aria-modal', 'true');
    w.setAttribute('aria-label', 'Frischfutter-Mindestbestellwert');
    w.innerHTML =
      '<div class="ds-bz-modal__backdrop" data-bz-close></div>'
      + '<div class="ds-bz-modal__card" role="document">'
      +   '<span class="ds-bz-modal__grip" data-bz-close aria-hidden="true"></span>'
      +   '<button type="button" class="ds-bz-modal__x" data-bz-close aria-label="Schließen">&times;</button>'
      +   '<h2 class="ds-bz-modal__title"></h2>'
      +   '<p class="ds-bz-modal__body"></p>'
      +   '<div class="ds-bz-modal__progress"><span></span></div>'
      +   '<p class="ds-bz-modal__lead">Das passt noch dazu</p>'
      +   '<div class="ds-bz-modal__suggest"></div>'
      +   '<button type="button" class="ds-bz-modal__remove" data-bz-remove></button>'
      + '</div>';
    document.body.appendChild(w);
    w.addEventListener('click', function(e) { if (e.target.closest('[data-bz-close]')) closeMovModal(); });
    w.querySelector('[data-bz-remove]').addEventListener('click', movRemoveBeutezeit);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && w.classList.contains('is-open')) closeMovModal();
    });
  }

  function renderMovModalState(cart) {
    var bz = 0, nonBz = 0;
    (cart.items || []).forEach(function(it) {
      var line = it.final_line_price != null ? it.final_line_price : it.line_price;
      if ((it.vendor || '') === MOV_VENDOR) bz += line; else nonBz += (it.quantity || 0);
    });
    var remaining = Math.max(0, MOV_THRESHOLD - bz);
    var pct = Math.min(100, (bz / MOV_THRESHOLD) * 100);
    var m = document.getElementById('ds-bz-modal');
    m.querySelector('.ds-bz-modal__title').textContent = 'Nur noch ' + formatEUR(remaining) + ' bis zur Kasse';
    m.querySelector('.ds-bz-modal__body').textContent =
      'Beutezeit wird in kleinen Chargen frisch in der Manufaktur gefertigt. Deshalb gilt für diese Produkte ein Mindestbestellwert von 15 €.';
    m.querySelector('.ds-bz-modal__progress > span').style.width = pct + '%';
    var rm = m.querySelector('.ds-bz-modal__remove');
    if (nonBz > 0) { rm.style.display = ''; rm.textContent = 'Ohne Beutezeit zur Kasse'; }
    else { rm.style.display = 'none'; }
    return { remaining: remaining, bz: bz };
  }

  function renderMovSuggest() {
    var box = document.querySelector('#ds-bz-modal .ds-bz-modal__suggest');
    if (!box || box.getAttribute('data-built') === '1') return;
    box.setAttribute('data-built', '1');
    MOV_SUGGEST.forEach(function(s) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ds-bz-modal__add';
      btn.innerHTML =
        '<img class="ds-bz-modal__add-thumb" alt="" loading="lazy">'
        + '<span class="ds-bz-modal__add-info"><span class="ds-bz-modal__add-name">' + s.n + '</span></span>'
        + '<span class="ds-bz-modal__add-price"></span>'
        + '<span class="ds-bz-modal__add-plus" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round"><path d="M12 5v14"></path><path d="M5 12h14"></path></svg></span>';
      btn.addEventListener('click', function() { movQuickAdd(btn); });
      box.appendChild(btn);
      fetch('/products/' + s.h + '.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(p) {
          var av = (p.variants || []).filter(function(v) { return v.available; }).sort(function(a, b) { return b.price - a.price; });
          if (!av.length) { btn.style.display = 'none'; return; }
          btn.setAttribute('data-bz-variant', av[0].id);
          btn.querySelector('.ds-bz-modal__add-price').textContent = formatEUR(av[0].price);
          var img = btn.querySelector('.ds-bz-modal__add-thumb');
          var src = p.featured_image || (p.images && p.images[0]) || '';
          if (src) {
            if (src.indexOf('//') === 0) src = 'https:' + src;
            src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
            img.src = src; img.alt = s.n;
          } else { img.style.display = 'none'; }
        })
        .catch(function() { btn.style.display = 'none'; });
    });
  }

  function openMovModal() {
    buildMovModal();
    var m = document.getElementById('ds-bz-modal');
    m.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    movTrack('modal_open');
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderMovModalState(cart); renderMovSuggest(); })
      .catch(function() {});
  }

  function closeMovModal() {
    var m = document.getElementById('ds-bz-modal');
    if (!m || !m.classList.contains('is-open')) return;
    m.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    movTrack('modal_close', { ds_bz_had_added: !!movDirty }); // Schliessen ohne Kasse = Abbruch-Signal (had_added=zwischendrin ergaenzt)
    if (movDirty) { movDirty = false; window.location.reload(); }
  }

  function movQuickAdd(btn) {
    var vid = btn.getAttribute('data-bz-variant');
    if (!vid) return;
    var prod = ((btn.querySelector('.ds-bz-modal__add-name') || {}).textContent || '').trim();
    btn.disabled = true;
    movTrack('suggest_click', { ds_bz_product: prod, ds_bz_variant_id: vid });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +vid, quantity: 1 }] }) })
      .then(function(r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js', { credentials: 'same-origin' }); })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        movDirty = true;
        var st = renderMovModalState(cart);
        state.beutezeitSum = st.bz; // Gate-State frisch halten (falls Kunde danach schliesst)
        var reached = st.bz >= MOV_THRESHOLD;
        movTrack('suggest_added', { ds_bz_product: prod, ds_bz_new_sum: +(st.bz / 100).toFixed(2), ds_bz_reached: reached });
        if (reached) { movTrack('reached_checkout', { ds_bz_final_sum: +(st.bz / 100).toFixed(2) }); window.location.href = '/checkout'; } // Schwelle erreicht -> direkt zur Kasse
        else { btn.disabled = false; }
      })
      .catch(function() { btn.disabled = false; });
  }

  function movRemoveBeutezeit() {
    movTrack('remove_click');
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var updates = {}, count = 0, value = 0;
        (cart.items || []).forEach(function(it) {
          if ((it.vendor || '') === MOV_VENDOR) { updates[it.key] = 0; count++; value += (it.final_line_price != null ? it.final_line_price : it.line_price); }
        });
        movTrack('removed_checkout', { ds_bz_removed_count: count, ds_bz_removed_value: +(value / 100).toFixed(2) });
        if (!Object.keys(updates).length) { window.location.href = '/checkout'; return; }
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
          .then(function() { window.location.href = '/checkout'; });
      })
      .catch(function() {});
  }

  // ── DOM: Frisch querien bei jedem Aufruf ──────────────────────────
  function getElements() {
    var bar = document.querySelector('.ds-shipping-bar');
    if (!bar) return null;
    return {
      bar: bar,
      fill: bar.querySelector('.ds-shipping-bar__fill'),
      message: bar.querySelector('.ds-shipping-bar__message'),
      icon: bar.querySelector('.ds-shipping-bar__icon'),
      track: bar.querySelector('.ds-shipping-bar__track')
    };
  }

  // ── Formatierung ──────────────────────────────────────────────────
  function formatEUR(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return euros + ' €';
  }

  // ── Sicherer DOM-Update-Helfer ────────────────────────────────────
  function setMessageContent(el, template, amount) {
    el.innerHTML = template.replace('{amount}', amount); // safe: keine User-Eingabe
  }

  function setInfoMode(els, template) {
    // Reiner Info-Modus: Truck-Icon, Text, KEIN Fortschrittsbalken
    if (els.icon) {
      els.icon.innerHTML = ICONS.truck;
      els.icon.classList.remove('ds-shipping-bar__icon--reached');
    }
    if (els.message) setMessageContent(els.message, template, '');
    if (els.track) els.track.style.display = 'none';
  }

  // ── Core Update ───────────────────────────────────────────────────
  function update(newTotal) {
    var els = getElements();
    if (!els) return;

    state.total = newTotal;

    // ── HOECHSTE PRIORITAET: Beutezeit-Mindestbestellwert (15 EUR) ──
    // Blockt Checkout NUR wenn 0 < Beutezeit-Anteil < 15 EUR (z.B. gemischter Korb: Geschirr + einzelner Snack).
    // Dieselbe Bar uebernimmt die MOV-Botschaft. Sonst: Block aus, normales Versand-Verhalten unveraendert.
    var movActive = state.beutezeitSum > 0 && state.beutezeitSum < MOV_THRESHOLD;
    applyCheckoutBlock(movActive);
    if (movActive) { renderMov(); return; }
    clearMovBars();

    // Sperrgut-Artikel (Transportbox) im Cart: hat IMMER eigenen Versand,
    // nie gratis. Vorrang vor jeder Gratis-Versand-Botschaft (kein falsches
    // Versprechen, kein Checkout-Schock). Pro Land die korrekte Gebuehr.
    if (state.hasSperrgut) {
      var fee = SPERRGUT_FEE[state.country] || SPERRGUT_FEE.DE;
      setInfoMode(els, MESSAGES.sperrgut.replace('{fee}', fee));
      return;
    }

    // Tiefkuehl-Artikel: eigenes Versandprofil (DPD Food Express 14,50), nie gratis. Vorrang vor Gratis-Botschaft.
    if (state.hasFrozen) {
      setInfoMode(els, MESSAGES.frozen);
      return;
    }

    // CH: nur ehrliche Info, kein Versprechen
    if (state.country === 'CH') {
      setInfoMode(els, MESSAGES.chInfo);
      return;
    }

    // AT: Status quo = ehrliche Info. Progression erst wenn Checkout-Regel
    // live ist (AT_FREE_THRESHOLD gesetzt) und kein schwerer Artikel im Cart.
    if (state.country === 'AT') {
      if (AT_FREE_THRESHOLD === null || state.hasHeavyItem) {
        setInfoMode(els, MESSAGES.atInfo);
        return;
      }
      renderProgress(els, AT_FREE_THRESHOLD, MESSAGES.atFar, MESSAGES.atAlmost, MESSAGES.atReached);
      return;
    }

    // DE (Default): unveraendertes Verhalten
    renderProgress(els, THRESHOLD, MESSAGES.far, MESSAGES.almost, MESSAGES.reached);
  }

  function renderProgress(els, threshold, farTpl, almostTpl, reachedTpl) {
    var remaining = Math.max(0, threshold - state.total);
    var pct = Math.min(100, (state.total / threshold) * 100);
    var reached = remaining === 0;

    if (els.track) els.track.style.display = '';

    // Fill: Breite + Farbe
    if (els.fill) {
      els.fill.style.width = pct + '%';
      els.fill.classList.toggle('ds-shipping-bar__fill--reached', reached);
    }

    // Icon: Truck <-> Check swap
    if (els.icon) {
      els.icon.innerHTML = reached ? ICONS.check : ICONS.truck; // safe: hardcoded strings
      els.icon.classList.toggle('ds-shipping-bar__icon--reached', reached);
    }

    // Message (3 Stufen: far / almost / reached)
    if (els.message) {
      var amount = formatEUR(remaining);
      if (reached) {
        setMessageContent(els.message, reachedTpl, '');
      } else if (remaining <= 2000) {
        setMessageContent(els.message, almostTpl, amount);
      } else {
        setMessageContent(els.message, farTpl, amount);
      }
    }

    // ARIA
    if (els.track) {
      els.track.setAttribute('aria-valuenow', String(Math.round(pct)));
    }

    // Schwelle erreicht -> dataLayer
    if (reached && !state.reachedBefore) {
      state.reachedBefore = true;
      pushEvent('ds_shipping_bar_reached', {
        ds_cart_value: +(state.total / 100).toFixed(2),
        ds_threshold: +(threshold / 100).toFixed(2),
        ds_geo_country: state.country,
        ds_products_in_cart: countCartItems()
      });
    }

    // Cart unter Schwelle gefallen -> State Reset
    if (!reached && state.reachedBefore) {
      state.reachedBefore = false;
    }
  }

  // ── Tracking Helpers ──────────────────────────────────────────────
  function pushEvent(name, params) {
    window.dataLayer = window.dataLayer || [];
    var evt = { event: name };
    for (var key in params) {
      if (params.hasOwnProperty(key)) evt[key] = params[key];
    }
    window.dataLayer.push(evt);
  }

  function countCartItems() {
    var items = document.querySelectorAll('[data-products] .cart__item, .cart__items .cart__item');
    return items.length;
  }

  // ── Event Listeners (IMMER registriert) ───────────────────────────

  // Mengen-Aenderung: cart:updated hat detail.cart mit total_price
  document.addEventListener('cart:updated', function(e) {
    if (e.detail && e.detail.cart && typeof e.detail.cart.total_price === 'number') {
      refreshHeavyFlag(e.detail.cart);
      update(e.detail.cart.total_price);
    }
  });

  // Produkt hinzugefuegt: kein Cart-Objekt im Event -> /cart.js fetchen
  document.addEventListener('ajaxProduct:added', function() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (typeof cart.total_price === 'number') {
          refreshHeavyFlag(cart);
          update(cart.total_price);
        }
      })
      .catch(function() { /* Netzwerkfehler -> Bar bleibt wie sie ist */ });
  });

  // Initiale Cart-Pruefung: setzt hasHeavyItem + hasSperrgut beim Laden,
  // damit der Sperrgut-/Heavy-Zustand sofort korrekt gerendert wird
  // (nicht erst nach dem ersten Cart-Event).
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      refreshHeavyFlag(cart);
      if (typeof cart.total_price === 'number') update(cart.total_price);
    })
    .catch(function() {});

  // View-Event einmalig pro Page-Load, mit Source-Segmentierung.
  // window-global Sentinel verhindert Doppelung wenn Skript 2x eingebunden
  // (Cart-Drawer-Snippet + Cart-Page-Section haben jeweils eigene IIFE-Closure).
  function fireViewIfNeeded(source) {
    if (state.viewFired || window.__dsShippingBarViewFired) return;
    state.viewFired = true;
    window.__dsShippingBarViewFired = true;
    var remaining = Math.max(0, THRESHOLD - state.total);
    pushEvent('ds_shipping_bar_view', {
      ds_cart_value: +(state.total / 100).toFixed(2),
      ds_threshold: +(THRESHOLD / 100).toFixed(2),
      ds_remaining: +(remaining / 100).toFixed(2),
      ds_threshold_reached: state.total >= THRESHOLD,
      ds_geo_country: state.country,
      ds_view_source: source
    });
  }

  // Pfad 1: Cart-Drawer oeffnet. Theme markiert via body.sn-cart-open
  // (verifiziert 2026-04-28). drawerOpen Custom-Event wird NICHT dispatched
  // vom aktuellen Theme — daher MutationObserver-only fuer Open-Signal.
  function watchBodyForCartOpen() {
    if (document.body.classList.contains('sn-cart-open')) {
      fireViewIfNeeded('drawer_open');
      return;
    }
    var bodyObs = new MutationObserver(function(records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].attributeName === 'class' && document.body.classList.contains('sn-cart-open')) {
          fireViewIfNeeded('drawer_open');
          return;
        }
      }
    });
    bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.body) watchBodyForCartOpen();
  else document.addEventListener('DOMContentLoaded', watchBodyForCartOpen);

  // Backwards-compat: drawerOpen Custom-Event falls Theme es doch dispatched
  document.addEventListener('drawerOpen', function(e) {
    var isCart = e.detail && (e.detail.id === 'CartDrawer' || /cart/i.test(e.detail.id || ''));
    if (isCart) fireViewIfNeeded('drawer_open');
  });
  document.addEventListener('drawerOpen.CartDrawer', function() {
    fireViewIfNeeded('drawer_open');
  });

  // ── Beutezeit-MOV: Cart-Mutationen zuverlaessig abfangen (Block + Bar) ──
  // window.fetch monkey-patch: nach jedem /cart/(add|change|update|clear) frisch aus /cart.js
  // neu rechnen. Garantiert, dass Block/Bar nie "offen" haengen bleiben (Checkout-Gate darf nicht fail-open).
  // Sentinel, weil das Script 2x eingebunden ist (Drawer + Cart-Page).
  if (!window.__dsBzMovHook) {
    window.__dsBzMovHook = 1;
    var _origFetch = window.fetch;
    if (_origFetch) {
      window.fetch = function() {
        // KRITISCH: immer window als this (NICHT this) — im strict-Wrapper waere this bei bare fetch() = undefined,
        // -> _origFetch.apply(undefined) wirft auf iOS Safari "Illegal invocation" und bricht Add-to-Cart. (Chrome tolerant.)
        var args = arguments, p = _origFetch.apply(window, args);
        try {
          var u = args[0], url = (typeof u === 'string') ? u : (u && u.url) || '';
          if (/\/cart\/(add|change|update|clear)/.test(url)) {
            p.then(function() {
              setTimeout(function() {
                _origFetch('/cart.js', { credentials: 'same-origin' })
                  .then(function(r) { return r.json(); })
                  .then(function(cart) {
                    refreshHeavyFlag(cart);
                    if (typeof cart.total_price === 'number') update(cart.total_price);
                  })
                  .catch(function() {});
              }, 150);
            });
          }
        } catch (e) {}
        return p;
      };
    }
    // ── FUNKTIONALER GATE (re-render-fest): faengt JEDEN Checkout-Versuch zentral ab,
    // per Selektor + Live-State, NICHT per Markierung am Element. Egal wie oft das Theme
    // die Buttons neu rendert (Mengen-/Add-Aenderung) -> jeder neue Button ist sofort gesperrt.
    var _coSel = 'button[name="checkout"],a[href="/checkout"],a[href^="/checkout?"],.additional-checkout-buttons,.dynamic-checkout__content,[data-shopify="dynamic-checkout-cart"]';
    document.addEventListener('click', function(e) {
      if (!movIsActive()) return;
      var t = e.target.closest ? e.target.closest(_coSel) : null;
      if (t) { e.preventDefault(); e.stopImmediatePropagation(); openMovModal(); }
    }, true);
    // Enter-/Programm-Submit eines Checkout-Formulars (submitter = checkout-Button) ebenfalls abfangen.
    document.addEventListener('submit', function(e) {
      if (!movIsActive()) return;
      var s = e.submitter;
      if (s && (s.getAttribute('name') === 'checkout' || /\/checkout/.test(s.getAttribute('formaction') || ''))) {
        e.preventDefault(); e.stopImmediatePropagation(); openMovModal();
      }
    }, true);
  }

  // Pfad 2: Direkter Cart-Page-Aufruf (/cart, /cart?...)
  if (window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart?') === 0
      || window.location.pathname === '/cart/') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        fireViewIfNeeded('cart_page_load');
      });
    } else {
      fireViewIfNeeded('cart_page_load');
    }
  }

})();
